import axios from 'axios'
import qs from 'qs'

const request = axios
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
axios.defaults.headers['X-Requested-With'] = 'X-Requested-With'

axios.interceptors.request.use(
  r => {
    if (r.method === 'post') {
      r.data = qs.stringify(r.data)
    }
    return r
  },
  e => {

  }
)

axios.interceptors.response.use(
  res => {
    if (res.data.code === 1) {
      return res.data.data
    }
  },
  e => {
  }
)

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js